// extracted by mini-css-extract-plugin
export var dividerLine = "_68-3";
export var itemImage = "_68-9";
export var lightDivider = "_68-4";
export var modalContent = "_68-5";
export var modalContentCompact = "_68-6";
export var productCard = "_68-a";
export var productImage = "_68-b";
export var productImageCompact = "_68-7";
export var productImagePlaceholder = "_68-c";
export var productImagePlaceholderCompact = "_68-8";
export var progressBarBackground = "_68-1";
export var progressBarContainer = "_68-0";
export var progressBarFill = "_68-2";